 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","8":"source~i18n-widgets-az-json","9":"source~i18n-widgets-en-json","10":"source~i18n-widgets-es-json","11":"source~i18n-widgets-es-mx-json","12":"source~i18n-widgets-tr-json","15":"source~/esports-betting-rules-TR","16":"source~bet-builder-rules-AZ","17":"source~bet-builder-rules-DE","18":"source~bet-builder-rules-EN","19":"source~bet-builder-rules-ES","20":"source~bet-builder-rules-ES-MX","21":"source~bet-builder-rules-ET","22":"source~bet-builder-rules-FI","23":"source~bet-builder-rules-FR","24":"source~bet-builder-rules-IT","25":"source~bet-builder-rules-JA","26":"source~bet-builder-rules-KA","27":"source~bet-builder-rules-LT","28":"source~bet-builder-rules-LV","29":"source~bet-builder-rules-PL","30":"source~bet-builder-rules-PT-BR","31":"source~bet-builder-rules-RO","32":"source~bet-builder-rules-RU","33":"source~bet-builder-rules-SQ","34":"source~bet-builder-rules-SV","35":"source~bet-builder-rules-TR","36":"source~bet-details-page","37":"source~betting-history-container","38":"source~betting-history-page","39":"source~betting-rules-AZ","40":"source~betting-rules-DA","41":"source~betting-rules-DE","42":"source~betting-rules-EN","43":"source~betting-rules-ES","44":"source~betting-rules-ES-MX","45":"source~betting-rules-FR","46":"source~betting-rules-IT","47":"source~betting-rules-JA","48":"source~betting-rules-PL","49":"source~betting-rules-PT","50":"source~betting-rules-PT-BR","51":"source~betting-rules-RO","52":"source~betting-rules-RU","53":"source~betting-rules-SQ","54":"source~betting-rules-SV","55":"source~betting-rules-TR","56":"source~bonus-info","57":"source~cashout-terms-AR","58":"source~cashout-terms-AZ","59":"source~cashout-terms-DA","60":"source~cashout-terms-DE","61":"source~cashout-terms-EN","62":"source~cashout-terms-ES","63":"source~cashout-terms-ES-MX","64":"source~cashout-terms-ET","65":"source~cashout-terms-FI","66":"source~cashout-terms-FR","67":"source~cashout-terms-IT","68":"source~cashout-terms-JA","69":"source~cashout-terms-KA","70":"source~cashout-terms-KU","71":"source~cashout-terms-LT","72":"source~cashout-terms-LV","73":"source~cashout-terms-PL","74":"source~cashout-terms-PT","75":"source~cashout-terms-PT-BR","76":"source~cashout-terms-RO","77":"source~cashout-terms-RU","78":"source~cashout-terms-SQ","79":"source~cashout-terms-SR","80":"source~cashout-terms-SV","81":"source~cashout-terms-TR","82":"source~esports-betting-rules-AZ","83":"source~esports-betting-rules-DA","84":"source~esports-betting-rules-DE","85":"source~esports-betting-rules-EN","86":"source~esports-betting-rules-ES","87":"source~esports-betting-rules-ES-MX","88":"source~esports-betting-rules-ET","89":"source~esports-betting-rules-FI","90":"source~esports-betting-rules-FR","91":"source~esports-betting-rules-IT","92":"source~esports-betting-rules-JA","93":"source~esports-betting-rules-KA","94":"source~esports-betting-rules-LT","95":"source~esports-betting-rules-LV","96":"source~esports-betting-rules-PL","97":"source~esports-betting-rules-PT","98":"source~esports-betting-rules-PT-BR","99":"source~esports-betting-rules-RO","100":"source~esports-betting-rules-RU","101":"source~esports-betting-rules-SQ","102":"source~esports-betting-rules-SR","103":"source~esports-betting-rules-SV","105":"source~generated-mappings","106":"source~i18n-az-json","107":"source~i18n-en-json","108":"source~i18n-es-json","109":"source~i18n-es-mx-json","110":"source~i18n-tr-json","112":"source~settings-page","113":"source~streaming-carousel","114":"source~virtual-esports-betting-rules-AZ","115":"source~virtual-esports-betting-rules-EN","116":"source~virtual-esports-betting-rules-IT","117":"source~virtual-esports-betting-rules-JA","118":"source~virtual-esports-betting-rules-PL","119":"source~virtual-esports-betting-rules-RU","121":"vendors~rc-slider","122":"vendors~react-google-recaptcha","123":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"4f4fca59916870d1a893","1":"43092256d2696fef72de","2":"363544d941ca822182db","3":"03cff2a495b5975129a5","4":"c492535f602fe543e2a8","5":"168b813896bf8b559270","6":"242f2111a7708c851d8f","8":"5cc29af6adad857509d8","9":"2065130b5d15452db9a9","10":"91d5b2b74110731d7a19","11":"13131313c5f22825ccb9","12":"598e2bd97277c9b1c080","15":"9aad918c07e0886184b5","16":"af53a1e561388f6b1785","17":"419ac035c4c214a15337","18":"18a4f93e72407df31dec","19":"98b9826ecf3423f900c4","20":"1a2ebd1d342d5e1746ee","21":"c77b3b356dd30a542598","22":"3fc50779b8e5fc9792e2","23":"eda6513f64da5b28496b","24":"43b68e4ed9f9aca257d2","25":"94c1b738ffcbbad79988","26":"44afc3931913e727e203","27":"ff1da81312886a7a28fa","28":"1c67b6fabfc98825266e","29":"a8b0a36d76c1dcb347f4","30":"ece9e3ed4a30573839a5","31":"034afe98dc5e6c815842","32":"b7dd6329e3d779d8ea5b","33":"8e71215b632a179d9e84","34":"72beacf9131f8c7462e4","35":"55deebd576c8ece6f03c","36":"1f3c93f9417715eac97b","37":"9412d207c07aaab9ef1d","38":"be1c3550cb983fa144f8","39":"4c8a1e4530b90863b1bb","40":"1266103e9e7a837ac59a","41":"a6ef3f72badb285eab2e","42":"1922dbc7d61dfc7cddc5","43":"37e938b71f908871336f","44":"d867f67f5915f8344fe1","45":"0b4bd51097235cfa2c68","46":"ed197b99ba489a5022a2","47":"6bbc7be37f31cc6eb139","48":"6cb9f06b150798db5207","49":"5c86d7da48e3ea8deffb","50":"0563eebd97c356c01e6b","51":"7014b2011b4badbec2d2","52":"96c3e5277e9417aab6eb","53":"99ad9626330cf99bd446","54":"4a3cd6f1556b4c07d3e4","55":"00f7a2433ad8c8dd3ed2","56":"08a491a1af5d85cfdb99","57":"8fb2b1b1045abb78b5bd","58":"615aa25edba3ff440a00","59":"c7a07b35cd01564a2ebd","60":"cbbc0bf390a6c13d26cf","61":"12fa75e4b8e06605c51a","62":"7040f691a32990ae0b7d","63":"fd5747a15de3e96f8036","64":"ed2a5f7e792e5b068f56","65":"86f4381cc5c79c4e95f1","66":"198f419e4180ca042f89","67":"1a74e8845aca0b13d931","68":"4a8f14c064a207be56a4","69":"7b9101503ffc61fedb81","70":"9c9a1f6f762733b52ed3","71":"7c91a6dd8de203634580","72":"1e44f9f70750f9f1365a","73":"100484e3ce362fa82b3f","74":"6a328bd93acf42dd7f90","75":"b93284c081f896aa7d96","76":"706611cf30390d21bd5c","77":"a6a57e2cf3abf8d817af","78":"92fe663421664ed86b6f","79":"88d1dd6d7eca1a63a0f4","80":"3cad9f5a789929179386","81":"dd71b6a811f9cdcbe541","82":"616b43edb0add8cf8490","83":"859521b561049b25d8a1","84":"9decb79c487ad3cf7472","85":"1b087cae3ebe9ffa6bbd","86":"819fd14092123a569d68","87":"ae7a257d798197813ed4","88":"2a8b422d901ff51ccf51","89":"23b623fdbf2a9733034e","90":"89913a6fb3ecf014bc22","91":"53307ec8d78bc86c1a4e","92":"bb692e4534c483d7ce7e","93":"b845c9e4d23bf47655f5","94":"b9003d08f474f7110435","95":"a094f34a634ac377dc12","96":"2fddb21b76899ac454c0","97":"3c98f7b84204d9b370d5","98":"9e6f38e5483c84b1c795","99":"66c9e711844fba693eff","100":"4cac299979235004ea2f","101":"47b909d431d6f4323178","102":"246bb569385e3a00e09b","103":"34177c75f34c5318166e","105":"3ca075a1bced1bb00aa1","106":"94be3fc56080925cc7ee","107":"3ccc3062d6e15f51513c","108":"64a40013b5f448bc7933","109":"ee01cce82277a35984e9","110":"024125e28b864b5ffaaa","112":"3778318a05e49f1afafd","113":"0dead3afd93a15fc9b1d","114":"5948809b054b1e1e4b34","115":"ad1e30f945aa1c3c241e","116":"62e9a94bce33be0e886a","117":"9899a5abdcaa2a8af5e5","118":"c5ac81eadf11e540c7be","119":"25a4b1d43d7c9787aaed","121":"d877a4f16f69c8c6b4a2","122":"2c77b72789f0d4cbbc22","123":"9b40512dd4c6348720aa","124":"3d5fea70a942b13a2030","125":"5deb9174645c51d6761a","126":"258c689f7bc77265d46a","127":"4f6f34b6b7cc8c3d4d9f","128":"64c9894b44a46eb5ab95","129":"4e74642a9308fea07e9f","130":"d9182480a7e999185573","131":"bd6da7873ef72e956f3e","132":"941fc73eb3f0cf1bc78d","133":"a6d6a6eda54cdd2fa234","134":"b6940a9e7431599ff5a0","135":"364d66f89e6a711798d6","136":"c47b9b3a8d8279810c67","137":"962eca4acc2b8f12f7cd","138":"a4647d7b7ce065982ba9","139":"c3f91c9708be324d3114","140":"1ef0b92413b7c5d478f5","141":"d206dc698db0db7eb99f","142":"b9d48e4fe4f32f452728","143":"930edcf3898af6367c1d","144":"f68b61ba7c3ff575a46f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
